import React from 'react';
import { DispatchMetrics } from '@catalogo/core-metrics';
import CollapseText from '@catalogo/theme-collapse-text';
import SvgAnswer from '@catalogo/ui-americanas-mobile-qna/src/svgs/answer.svg';
import Feedback from '../Feedback';
import { Answer, AnswerCreatedAt, AnswerOwner, AnswerDesk, SvgAnswerBox, Container, Wrapper } from './styled';
import collapseTextProps from '../../../helpers/collapseTextProps';
import { IAnswerBox } from '../../../types';

const AnswerBox = ({ answer, question, isDesk }: IAnswerBox) => {
  const metric = (collapseActive: boolean, dispatchMetrics: DispatchMetrics) => {
    const action = collapseActive ? 'expandir-resposta' : 'retrair-resposta';
    dispatchMetrics('event:track', { category: 'qna-pdp', action });
    return null;
  };

  const { fontSize, maxTextLength, defaultTextHeight } = collapseTextProps(isDesk);

  const answerText = isDesk ? (
    <Wrapper>
      <AnswerDesk>
        Respondida por {answer?.owner} em {answer?.createdAt}
      </AnswerDesk>
      <Feedback
        evaluation={question?.evaluation}
        questionId={question?.id}
        answerId={question?.answer?.id}
        isDesk={isDesk}
      />
    </Wrapper>
  ) : (
    <>
      <AnswerOwner>Respondida por {answer?.owner} em</AnswerOwner>
      <AnswerCreatedAt>{answer?.createdAt}</AnswerCreatedAt>
      <div>
        <Feedback
          evaluation={question?.evaluation}
          questionId={question?.id}
          answerId={question?.answer?.id}
          isDesk={isDesk}
        />
      </div>
    </>
  );

  return (
    <Container isDesk={isDesk}>
      <SvgAnswerBox isDesk={isDesk}>
        <SvgAnswer />
      </SvgAnswerBox>
      <div>
        <Answer>
          <CollapseText
            fontSize={fontSize}
            text={answer?.text}
            maxTextLength={maxTextLength}
            defaultTextHeight={defaultTextHeight}
            onChange={metric}
          />
        </Answer>
        {answerText}
      </div>
    </Container>
  );
};

export default AnswerBox;
